import apiService from './api';

const vaccineCatalogService = {
  getTypes() {
    return apiService.get('/vaccine-catalog/types');
  },

  list(params = {}) {
    return apiService.get('/vaccine-catalog', { params });
  },

  getById(id) {
    return apiService.get(`/vaccine-catalog/${id}`);
  },

  create(payload) {
    return apiService.post('/vaccine-catalog', payload);
  },

  update(id, payload) {
    return apiService.put(`/vaccine-catalog/${id}`, payload);
  },

  remove(id) {
    return apiService.delete(`/vaccine-catalog/${id}`);
  }
};

export default vaccineCatalogService;
